import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import background from "../assets/background.png";
import GameResult from "./GameResult";
import GameResultTest from "./GameResultTest";
import LoadingScreen from "./LoadingScreen";
import useAuth from "../../auth/hooks/useAuth";
import UpdateProgress from "../functions/UpdateProgress";
import { Scale } from 'react-scaling';
import game_data from "../../games/game_data";
import Rankings from "../hooks/useRankings";
import useTamagotchis from "../hooks/useTamagotchis";

export default function PracticeGame({ ...props }) {
    console.log(props);
    if (props.parent.TestingAssignment == true) {
        return TestAssignment(props);
    }else{
        return Game(props);
    }
}

var total_time = 0;

function TestAssignment({...props}){
    // console.log(props);
    function ReturnGameID(){
     var id = 0;
     var game = props.parent.gameType;
     for (let i = 0; i < props.gameData.length; i++) {
         const element = props.gameData[i];
         if (game == element.game_type){
             id = element.id;
             break;
         }
     }
     return id;
 }
 const [remainingTime, setRemainingTime] = useState(
     props.defaultTimer ? props.defaultTimer : 30
 );
 const [showFeedback, setShowFeedback] = useState(false);
 props.gameData = game_data;
 
 const [remainingQuestions, setRemainingQuestions] = useState(
    props.questionLimit ? props.questionLimit : -1
);

 const [answerTime, setAnswerTime] = useState(0);

 const [savedSubmission, setSavedSubmission] = useState(false);


 useEffect(() => {
    if(remainingQuestions < 0)
{
     if (remainingTime > 0) {
         var timerID = setInterval(() => decrementTimer(), 1000);
         return () => {
             clearInterval(timerID);
         };
     } else {
 
         //UpdateProgress(props);
 
 
         let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
         let total_time_taken =  total_time.toFixed(2);

         let correctByTopics = correct.reduce((byTopics, question) => {
             byTopics[question.topic_id] = byTopics[question.topic_id] || [];
             byTopics[question.topic_id].push(question);
             return byTopics;
         }, {});
         let incorrectByTopics = incorrect.reduce((byTopics, question) => {
             byTopics[question.topic_id] = byTopics[question.topic_id] || [];
             byTopics[question.topic_id].push(question);
             return byTopics;
         }, {});
 
         window.correctByTopics = correctByTopics;
         window.incorrectByTopics = incorrectByTopics;
 
         let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
             let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
             let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
             let tempTopicID = parseInt(topic_id);
             let tempAverageAnswerTime = parseFloat(average_ans_time);
             let totalTime = parseFloat(total_time_taken);
             return {
                 topic_id: tempTopicID,
                 num_correct,
                 num_asked: num_correct + num_incorrect,
                 average_ans_time: tempAverageAnswerTime,
                 total_time_taken: totalTime
             }
         });
         
         console.log(props);
     }
    }
 }, [remainingTime]);


var correctAmount = props.correct ? props.correct.length : 0;
var incorrectAmount = props.incorrect ? props.incorrect.length : 0;
var answeredTotal = correctAmount + incorrectAmount;


useEffect(() => {
    if(remainingQuestions > 0)
{
    if (remainingQuestions == answeredTotal) 
    {
        setRemainingTime(0);
        //UpdateProgress(props);


        let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
        let total_time_taken =  total_time.toFixed(2);

        let correctByTopics = correct.reduce((byTopics, question) => {
            byTopics[question.topic_id] = byTopics[question.topic_id] || [];
            byTopics[question.topic_id].push(question);
            return byTopics;
        }, {});
        let incorrectByTopics = incorrect.reduce((byTopics, question) => {
            byTopics[question.topic_id] = byTopics[question.topic_id] || [];
            byTopics[question.topic_id].push(question);
            return byTopics;
        }, {});

        window.correctByTopics = correctByTopics;
        window.incorrectByTopics = incorrectByTopics;

        let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
            let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
            let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
            let tempTopicID = parseInt(topic_id);
            let tempAverageAnswerTime = parseFloat(average_ans_time);
            let totalTime = parseFloat(total_time_taken);
            return {
                topic_id: tempTopicID,
                num_correct,
                num_asked: num_correct + num_incorrect,
                average_ans_time: tempAverageAnswerTime,
                total_time_taken: totalTime
            }
        });
        
        console.log(props);
    }
}
}, [answeredTotal]);


 

 function TimerZero() {
     setRemainingTime(0);
 }
 
 function decrementTimer() {
    if(remainingQuestions < 0)
    {
    setRemainingTime(remainingTime - 1);
    }
 }

 function incrementTimer(){
      setAnswerTime(answerTime + 1);
	}
 
 function restartGame() {
     props.restart();
     setRemainingTime(props.defaultTimer ? props.defaultTimer : 30);
 }

 function resetTimer(){
     total_time = 0;
	}
 
 const {
     children,
     correct,
     incorrect,
     score,
     onBack,
     loading,
     feedback,
     nofeedback,
     questionFontSize
 } = props;
 
 return (
     <ApplicationContainer>
         <Scale scaleTo={1720}>
             <ApplicationHeader>
                 <LeftHeader>
                     <Score>{score}</Score>
                 </LeftHeader>
                 <CenterHeader>
                 {remainingQuestions > 0 ? (
                        <Timer>{(correct.length + incorrect.length)}/{remainingQuestions}</Timer>
                    ):(
                        <Timer>{remainingTime}</Timer>
                    )}
                 </CenterHeader>
                 <RightHeader>
                     <IncorrectCount>{incorrect.length}</IncorrectCount>
                     <CorrectCount>{correct.length}</CorrectCount>
                 </RightHeader>
             </ApplicationHeader>
         </Scale>
         {remainingTime > 0 && !loading ? (
                 children
         ) : loading ? (
             <LoadingScreen />
         ) : (
                     <GameResultTest
                         feedback={feedback}
                         questionFontSize={questionFontSize}
                         score={score}
                         correct={correct.length}
                         incorrect={incorrect.length}
                         onRestartGame={() => {
                         restartGame();
                         resetTimer();
                         }}
                         onBack={() => {
                         props.onBack();
                         resetTimer();
                         }}
                         isRating={false}
                         speed={parseFloat(
                             (props.defaultTimer ? props.defaultTimer : 30) /
                             (correct.length + incorrect.length)
                         ).toFixed(2)}
                         total={total_time.toFixed(2)}
                     />
                 )}
 
     </ApplicationContainer>
 );
 }

function Game({ ...props }) {
    function ReturnGameID(){
        var id = 0;
        var game = props.parent.gameType;
        for (let i = 0; i < props.gameData.length; i++) {
            const element = props.gameData[i];
            if (game == element.game_type){
                id = element.id;
                break;
            }
        }
        return id;
    }
    var gottama = false;
    const tamagotchis = useTamagotchis();
    const [tama, setTama] = useState([]);
    useEffect(() => {
    if (tamagotchis != undefined && gottama == false) {
        console.log("set tama");
           setTama(tamagotchis);
           gottama = true;
        }
    }, [tamagotchis]);
    
    const [remainingTime, setRemainingTime] = useState(
        props.defaultTimer ? props.defaultTimer : 30
    );
    const [showFeedback, setShowFeedback] = useState(false);
    const { state: authState } = useAuth();
    const [savedSubmission, setSavedSubmission] = useState(false);

    const [remainingQuestions, setRemainingQuestions] = useState(
        props.questionLimit ? props.questionLimit : -1
    );

     const [answerTime, setAnswerTime] = useState(0);

    props.rankings = [];
    if (props.parent.gameType == "multiplication") {
        props.rankings = Rankings({ service_key: "timetables" });
    } else {
        props.rankings = Rankings({ service_key: props.parent.gameType });
    }
    props.token = authState;
    props.gameData = game_data;


    useEffect(() => {
        if(remainingQuestions < 0)
        {
        if (remainingTime > 0) {
            var timerID = setInterval(() => decrementTimer(), 1000);
            return () => {
                clearInterval(timerID);
            };
        } else {
            console.log(props);
            //UpdateProgress(props);
            let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
            let total_time_taken =  total_time.toFixed(2);

            let correctByTopics = correct.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            let incorrectByTopics = incorrect.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});

            window.correctByTopics = correctByTopics;
            window.incorrectByTopics = incorrectByTopics;

            let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
                let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
                let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
                console.log("topicID");
                console.log(topic_id);
                let tempTopicID = parseInt(topic_id);
                let tempAverageAnswerTime = parseFloat(average_ans_time);
                let totalTime = parseFloat(total_time_taken);
                return {
                    topic_id: tempTopicID,
                    num_correct,
                    num_asked: num_correct + num_incorrect,
                    average_ans_time: tempAverageAnswerTime,
                    total_time_taken: totalTime
                }
            });

            var questionsAnswered = [];
            if (nofeedback != undefined) {
                feedback.forEach(element => {
                    //questionsAnswered.push(element);
                    let data = {
                        question: element.question,
                        correct: false,
                        answer: element.incorrect
                    };
                    questionsAnswered.push(data);
                });
                nofeedback.forEach(element => {
                    let data = {
                        question: element.question,
                        correct: true,
                        answer: element.incorrect
                    };
                    questionsAnswered.push(data);
                });
                //then sned this with network
                console.log(JSON.stringify(questionsAnswered));
            }

            axios({
                url: `${process.env.REACT_APP_API}/submissions`,
                method: "post",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authState.access_token}`
                },
                data: {
                    "homework_id": props.parent.homework_id,
                    "topicstats": topicstats,
                    "platform": "Practice|"+"WEB"+"|"+process.env.REACT_APP_VERSION_NO,
                    "custom":props.custom,
                    "game_id":props.parent.gameData.id,
                    "questionsAnswered": JSON.stringify(questionsAnswered)
                }
            }).then((response) => {
                console.log(response);
                if (response.status == 201){
                    setSavedSubmission(true);
                }else{
                    console.log("Failed to save submission");
                }
            });
        }
        }
    }, [remainingTime]);

var correctAmount = props.correct ? props.correct.length : 0;
var incorrectAmount = props.incorrect ? props.incorrect.length : 0;
var answeredTotal = correctAmount + incorrectAmount;


    useEffect(() => {
        if(remainingQuestions > 0)
        {
        if (remainingQuestions == answeredTotal) 
        {
            setRemainingTime(0);
            //UpdateProgress(props);
            let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
            let total_time_taken =  total_time.toFixed(2);

            let correctByTopics = correct.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            let incorrectByTopics = incorrect.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});

            window.correctByTopics = correctByTopics;
            window.incorrectByTopics = incorrectByTopics;

            let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
                let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
                let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
                console.log("topicID");
                console.log(topic_id);
                let tempTopicID = parseInt(topic_id);
                let tempAverageAnswerTime = parseFloat(average_ans_time);
                let totalTime = parseFloat(total_time_taken);
                return {
                    topic_id: tempTopicID,
                    num_correct,
                    num_asked: num_correct + num_incorrect,
                    average_ans_time: tempAverageAnswerTime,
                    total_time_taken: totalTime
                }
            });

            console.log(props);
            //console.log(correct);
            //console.log(incorrect);
            console.log(nofeedback);
            console.log(feedback);
            var questionsAnswered = [];
            if (nofeedback != undefined) {
                feedback.forEach(element => {
                    //questionsAnswered.push(element);
                    let data = {
                        question: element.question,
                        correct: false,
                        answer: element.incorrect
                    };
                    questionsAnswered.push(data);
                });
                nofeedback.forEach(element => {
                    let data = {
                        question: element.question,
                        correct: true,
                        answer: element.incorrect
                    };
                    questionsAnswered.push(data);
                });
                //then sned this with network
                console.log(JSON.stringify(questionsAnswered));
            }

            axios({
                url: `${process.env.REACT_APP_API}/submissions`,
                method: "post",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authState.access_token}`
                },
                data: {
                    "homework_id": props.parent.homework_id,
                    "topicstats": topicstats,
                    "platform": "Practice|"+"WEB"+"|"+process.env.REACT_APP_VERSION_NO,
                    "custom":props.custom,
                    "game_id":props.parent.gameData.id,
                    "questionsAnswered": JSON.stringify(questionsAnswered)
                }
            }).then((response) => {
                console.log(response);
                if (response.status == 201){
                    setSavedSubmission(true);
                }else{
                    console.log("Failed to save submission");
                }
            });
        }
    }
    }, [answeredTotal]);

 useEffect(() => {
            var secondTimerID = setInterval(() => incrementTimer(), 1000);
            return () => {
                clearInterval(secondTimerID);
            };
	});

  //effect here --------------------------------------------
    useEffect(() => {
    total_time = total_time + answerTime;
    setAnswerTime(0);   
	}, [props.correct.length])

    function decrementTimer() {
        if(remainingQuestions < 0)
        {
        setRemainingTime(remainingTime - 1);
        }
    }

      function incrementTimer(){
      setAnswerTime(answerTime + 1);
	}

    function TimerZero() {
        setRemainingTime(0);
    }

    function restartGame() {
        props.restart();
        setRemainingTime(props.defaultTimer ? props.defaultTimer : 30);
    }

    function resetTimer(){
     total_time = 0;
	}

    function EarlySubmission(){
        //UpdateProgress(props);

            let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
            let total_time_taken = total_time.toFixed(2);
            

            let correctByTopics = correct.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            let incorrectByTopics = incorrect.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});

            window.correctByTopics = correctByTopics;
            window.incorrectByTopics = incorrectByTopics;
            


            let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
                let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
                let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
                let tempTopicID = parseInt(topic_id);
                let tempAverageAnswerTime = parseFloat(average_ans_time);
                let totalTime = total_time_taken;
                return {
                    topic_id: tempTopicID,
                    num_correct,
                    num_asked: num_correct + num_incorrect,
                    average_ans_time: tempAverageAnswerTime,
                    total_time_taken: totalTime
                }
            });

            console.log(props);
            //console.log(correct);
            //console.log(incorrect);
            console.log(nofeedback);
            console.log(feedback);
            var questionsAnswered = [];
            if (nofeedback != undefined) {
                feedback.forEach(element => {
                    //questionsAnswered.push(element);
                    let data = {
                        question: element.question,
                        correct: false,
                        answer: element.incorrect
                    };
                    questionsAnswered.push(data);
                });
                nofeedback.forEach(element => {
                    let data = {
                        question: element.question,
                        correct: true,
                        answer: element.incorrect
                    };
                    questionsAnswered.push(data);
                });
                //then sned this with network
                console.log(JSON.stringify(questionsAnswered));
            }
            axios({
                url: `${process.env.REACT_APP_API}/submissions`,
                method: "post",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authState.access_token}`
                },
                data: {
                    "homework_id": props.parent.homework_id,
                    "topicstats": topicstats,
                    "platform": "Practice|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO + "|incomplete",
                    "custom": props.custom,
                    "game_id": props.parent.gameData.id,
                    "questionsAnswered": JSON.stringify(questionsAnswered)
                }
            }).then((response) => {
                console.log(response);
                if (response.status == 201){
                    setSavedSubmission(true);
                }else{
                    console.log("Failed to save submission");
                }
            });

        //then go back
        onBack();
        resetTimer();
    }

    function AreYouSureBack(){

        if (props.parent.homework_id != null && props.parent.homework_id != ""){
            if (window.confirm("If you leave the task part done it will show as incomplete and you will have to start again.")){
                EarlySubmission();
            }
        }else{
            if (window.confirm("are you sure you want to exit?")){
                EarlySubmission();
            }
        }
    }

    const {
        children,
        correct,
        incorrect,
        score,
        onBack,
        loading,
        feedback,
        nofeedback,
        questionFontSize
    } = props;

    return (
        <ApplicationContainer>
            <Scale scaleTo={1720}>
                <ApplicationHeader>
                    <LeftHeader>
                        <Score>{score}</Score>
                    </LeftHeader>
                    <CenterHeader>
                    {remainingQuestions > 0 ? (
                        <Timer>{(correct.length + incorrect.length)}/{remainingQuestions}</Timer>
                    ):(
                        <Timer>{remainingTime}</Timer>
                    )}
                    </CenterHeader>
                    <RightHeader>
                        <IncorrectCount>{incorrect.length}</IncorrectCount>
                        <CorrectCount>{correct.length}</CorrectCount>
                        <Back onClick={AreYouSureBack}>Back</Back>
                    </RightHeader>
                </ApplicationHeader>
            </Scale>
            {remainingTime > 0 && !loading ? (
                children
            ) : loading ? (
                <LoadingScreen/>
            ) : (
                        <GameResult
                            neveragain={props.parent.neveragain}
                            feedback={feedback}
                            questionFontSize={questionFontSize}
                            score={score}
                            correct={correct.length}
                            incorrect={incorrect.length}
                            onRestartGame={() => {
                            restartGame();
                            resetTimer();
                            }}
                             onBack={() => {
                             props.onBack();
                             resetTimer();
                            }}
                            isRating={false}
                            speed={parseFloat(
                                (props.defaultTimer ? props.defaultTimer : 30) /
                                (correct.length + incorrect.length)
                            ).toFixed(2)}
                            total={total_time.toFixed(2)}
                            canExit={savedSubmission}
                        />
                    )}
        </ApplicationContainer>
    );
}

const ApplicationContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: #fff;
`;

const ApplicationHeader = styled.div`
    width: 100%;
    height: 60px;
    background: #683d8c;
    justify-content: space-around;
    display: flex;
`;

const LeftHeader = styled.div`
    width: 30%;
    display: flex;
    justify-content: flex-end;
`;

const RightHeader = styled.div`
    width: 30%;
    display: flex;
`;

const CenterHeader = styled.div`
    width: 30%;
    display: flex;
    justify-content: center;
`;

const Timer = styled.div`
    width: 200px;
    height: 80px;
    background: #ef3e37;
    text-align: center;
    font-size: 3em;
    font-weight: 600;
    color: #fff;
    line-height: 80px;
    margin-top: 0px;
    border-radius: 0px 0px 15px 15px;
    z-index: 11;
`;

const ApplicationBody = styled.div`
    width: 100%;
    height: 100%;
    background: #2a64a4;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
`;

const ApplicationResult = styled.div`
    height: 100%;
    z-index: 10;
    background: #fff;
    background-image: url(${background});
    padding: 150px;
    font-size: 3em;
    border: solid 2px #683d8c;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const IncorrectCount = styled.div`
    margin-top: 10px;
    width: 50px;
    height: 40px;
    background: #ef3e37;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
`;

const CorrectCount = styled.div`
    width: 50px;
    height: 40px;
    margin-top: 10px;
    background: #42b231;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 5px;
`;

const Score = styled.div`
    width: 150px;
    height: 40px;
    margin-top: 10px;
    background: #4b2e6b;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 20px;
`;

const Back = styled.div`
    width: 150px;
    height: 40px;
    margin-top: 10px;
    background: #4b2e6b;
    user-select: none;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 20px;
    &:hover {
        cursor: pointer;
    }
`;

const ResultScores = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;
    flex-direction: column;
`;

const Result = styled.div`
    display: flex;
`;
const ResultValue = styled.div`
    margin: 0px 20px;
    border: solid #e4e4e4 2px;
    background: #fff;
    padding: 0px 15px;
`;

const Banner = styled.div`
    position: absolute;
    left: 50%;
    display: block;
    margin: 100px -200px;
    width: 400px;
    height: 60px;
    border: 1px solid #e88f12;
    font: normal 30px/60px;
    line-height: 60px;
    font-weight: 600;
    text-align: center;
    color: #fff;
    background: rgba(255, 186, 32, 1);
    border-radius: 4px;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.15) inset, 0 6px 10px rgba(0, 0, 0, 0.15);
    &::before,
    ::after {
        content: "";
        position: absolute;
        z-index: -1;
        left: -70px;
        top: 24px;
        display: block;
        width: 40px;
        height: 0px;
        border: 30px solid #e88f12;
        border-right: 20px solid #c97e11;
        border-bottom-color: #e88f12;
        border-left-color: transparent;
        transform: rotate(-5deg);
    }

    &::after {
        left: auto;
        right: -70px;
        border-left: 20px solid #c97e11;
        border-right: 30px solid transparent;
        transform: rotate(5deg);
    }
`;
